module.exports = __webpack_public_path__ + "media/toolkits/comments-dollar-light-c6d74423.svg";